import type { BadgeVariant } from '@/components/common/Badge';
import type { PaperJournalStatus } from '@/app/types/paperJournal';

export function paperJournalStatusBadgeVariant(status: PaperJournalStatus): BadgeVariant {
  if (status === 'PROCESSED') {
    return 'success';
  }
  if (status === 'PENDING') {
    return 'warning';
  }
  return 'danger';
}
